import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { GoogleOAuthProvider } from '@react-oauth/google';
import { APIProvider } from '@vis.gl/react-google-maps';
import * as Sentry from "@sentry/react";

import './index.css'

if (!window.location.href.includes("localhost")) {
  Sentry.init({
    dsn: "https://6ac2b03532a6c81ff8b8ddf76f92a862@o4507575594713088.ingest.us.sentry.io/4507575608475648",
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.5, //  Capture 50% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/app\.mp2\.in/,/^https:\/\/app\.prorouting\.in/],
  });
}

// Import the generated route tree
import { routeTree } from './routeTree.gen'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { googleApiKey } from '@/lib/utils';

// Create a new router instance
const router = createRouter({ routeTree })
const queryClient = new QueryClient()

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Render the app
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <GoogleOAuthProvider clientId="4829522009-9abosnmjctlupo9t8alm7i674jbinh0o.apps.googleusercontent.com">
        <APIProvider apiKey={googleApiKey}>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
          </QueryClientProvider>
        </APIProvider>
      </GoogleOAuthProvider>
    </StrictMode>,
  )
}
